// ============================================================
// Main Entry Point - Code Dragon Portfolio
// ============================================================

// Import Styles
import '../styles/main.scss';
import '../styles/navbar.scss';
import '../styles/hero.scss';
import '../styles/about.scss';
import '../styles/certifications.scss';
import '../styles/features.scss';
import '../styles/portfolio.scss';
import '../styles/contact.scss';
import '../styles/footer.scss';

// Import Assets
import dragonLogo from '../assets/m.png';

// Import Modules
import { initNavbar } from './modules/navbar.js';
import { initHeroAnimations } from './modules/hero.js';
import { initI18n, onLocaleChange } from './modules/i18n.js';
import { initScrollAnimations } from './modules/scrollAnimations.js';
import { initCertifications } from './modules/certifications.js';
import { initFeatures } from './modules/features.js';
import { initPortfolioCards } from './modules/portfolio.js';
import { initContactForm } from './modules/contact.js';

// ============================================================
// Initialize App
// ============================================================

document.addEventListener('DOMContentLoaded', () => {
    // Set logo images from imported asset
    const logoImages = document.querySelectorAll('.logo-img, .dragon-img');
    logoImages.forEach(img => {
        img.src = dragonLogo;
    });

    // Initialize all modules
    initNavbar();
    initI18n();
    initHeroAnimations();
    initCertifications();
    initScrollAnimations();
    initFeatures();
    initPortfolioCards();
    initContactForm();

    onLocaleChange(() => {
        initHeroAnimations(true);
    });
});
